export default "__VITE_ASSET__cuLsv9JL__"